import * as angular from "angular";
import "angular-ui-router";
import "angular-ui-bootstrap";
import "ui-select";
import "angular-resource";
import {UserService as userService} from './core/services/UserService'
import {MinistryService as ministryService} from './core/services/MinistryService'
import {AgencyService as agencyService} from './core/services/AgencyService'
import {ClassificationService as classificationService} from './core/services/ClassificationService';
import {DatatypesService as datatypeService} from "./core/services/DatatypeService";
import {AdminPageComponent} from './components/adminPage/AdminPageComponents';
import {UserManagementPageComponent} from './components/userManagementPage/UserManagementPageComponent';
import {UserModalComponent} from './components/userManagementPage/UserModalComponent';
import {UserDetailModalComponent} from './components/userManagementPage/UserDetailModalComponent';
import {OrganizationManagementPageComponent} from './components/organizationManagementPage/OrganizationManagementPageComponent'
import {MinistryModalComponent} from './components/organizationManagementPage/MinistryModalComponent';
import {AgencyModalComponent} from './components/organizationManagementPage/AgencyModalComponent';
import {ClassificationManagementPageComponent} from './components/classificationManagementPage/ClassificationManagePageComponent';
import {ClassificationModalComponent} from './components/classificationManagementPage/ClassificationModalComponent';
import {DataManagementPageComponent} from './components/dataManagementPage/DataManagementPageComponent';
import {DatatypeModalComponent} from './components/dataManagementPage/DatatypeModalComponent';
import {ConfigurationManagementPageComponent} from './components/configurationManagementPage/ConfigurationManagementPageComponent';
import {TestEmailModalComponent} from './components/configurationManagementPage/TestEmailModalComponent';
import {ReportPageComponent} from './components/reportPage/ReportPageComponent';
import {ReportDetailModalComponent} from './components/reportPage/ReportDetailModal';
import {RejectionModalComponent} from './components/userManagementPage/RejectionModalComponent';
import {ReminderLogModalComponent} from './components/dataManagementPage/ReminderLogModalComponent';
import {ExternalDatasetManagementPageComponent} from "./components/externalDatasetManagementPage/ExternalDatasetManagementPageComponent";
import {ManualFetchingModal} from "./components/dataManagementPage/ManualFetchingModal"
import {config as routesConfig} from "./configs/routes";

angular.module("app.admin", ["ui.router", "ui.bootstrap", "ui.select", "ngResource"])
    .service("UserService", userService)
    .service("MinistryService", ministryService)
    .service("AgencyService", agencyService)
    .service("ClassificationService", classificationService)
    .service("DatatypeService", datatypeService)
    .component("adminPage", new AdminPageComponent())
    .component("userManagement", new UserManagementPageComponent())
    .component("userModal", new UserModalComponent())
    .component("rejectionModal", new RejectionModalComponent())
    .component("userDetailModal", new UserDetailModalComponent())
    .component("organizationManagement", new OrganizationManagementPageComponent())
    .component("ministryModal", new MinistryModalComponent())
    .component("agencyModal", new AgencyModalComponent())
    .component("classificationManagement", new ClassificationManagementPageComponent())
    .component("classificationModal", new ClassificationModalComponent())
    .component("datasManagement", new DataManagementPageComponent())
    .component("datatypeModal", new DatatypeModalComponent())
    .component("reminderLogModal", new ReminderLogModalComponent())
    .component("configurationManagement", new ConfigurationManagementPageComponent())
    .component("testEmailModal", new TestEmailModalComponent())
    .component("reportPage", new ReportPageComponent())
    .component("reportDetailModal", new ReportDetailModalComponent())
    .component("externalDatasetPage", new ExternalDatasetManagementPageComponent())
    .component("manualFetchingModal", new ManualFetchingModal())
    .config(routesConfig);
